export default "__VITE_ASSET__c2d80a43__"